export const init = () => {
    
	if (document.querySelector('.js-doc-nav-section')) { 
		let all_el_doc_nav_sections = document.querySelectorAll('.js-doc-nav-section .title');
		let all_el_doc_nav_items = document.querySelectorAll('.js-list-item');
		let all_el_doc_content = document.querySelectorAll('.js-doc-content');
		let el_doc_nav_item_ID;
		let el_nav_burger = document.querySelector('.js-burger');
		let el_sidebar = document.querySelector('.s-doc-sidebar');
		const sheet = document.querySelector('style');
		all_el_doc_nav_sections.forEach(function(cur) {
			cur.addEventListener('click', function() { 
				cur.parentElement.classList.toggle('active'); 
			})
		});

		function showPage(data_content_id, url_page_id) { 
			if(url_page_id && data_content_id >= 0) { 
				window.location.hash = url_page_id; 
			}
			else {  
				url_page_id = window.location.hash.split('#');
				data_content_id = document.querySelector(`[data-page=${url_page_id[1]}]`).dataset.nav_id; 
			}  
			document.querySelector(`.js-doc-content[data-content_id="${data_content_id}"]`) ? sheet.innerHTML = `.s-doc-content__wrapper[data-content_id="${data_content_id}"] {display: block;}` : alert("Content pro tento prvek neexistuje!");
		}

		all_el_doc_nav_items.forEach(function(cur, index) {
			cur.dataset.nav_id = index;
			cur.addEventListener('click', function(el) {
				all_el_doc_nav_items.forEach((item) => {item.classList.remove('active')});
				cur.classList.add('active');
				el_sidebar.classList.remove('active');
				el_doc_nav_item_ID = Number(this.dataset.nav_id);
				
				// Solution for dynamic URL 
				const data_id = cur.dataset.page; 
				showPage(el_doc_nav_item_ID, data_id);  
			})
		});
		all_el_doc_content.forEach(function(cur, index) {
			cur.dataset.content_id = index;
		});
		el_nav_burger.addEventListener('click', function() {
			el_sidebar.classList.toggle('active');
		}) 

		showPage();  
		

	}
};
